import { useFormContext } from "react-hook-form";
import {
  type Maybe,
  type FormSectionSelect_Fields,
} from "~/__generated__/graphql";
import FormSelect from "~/components/forms/Elements/Select";
import { FormFieldRenderer } from "./FormFieldRenderer";

export default function Select({
  label,
  placeholder,
  choices,
  required,
}: FormSectionSelect_Fields) {
  const safeLabel = label?.replace("'", "");
  const { control, watch } = useFormContext();
  const value = watch(safeLabel!) as string;
  const conditionalFields = choices?.find(
    (choice) => choice?.name === value,
  )?.conditionalFields;

  return (
    <>
      <div className="space-y-2">
        <label htmlFor={safeLabel} className="text-lg font-medium text-white">
          {label}
        </label>
        <FormSelect
          name={safeLabel!}
          placeholder={placeholder ?? ""}
          // defaultValue={defaultSubject}
          control={control}
          required={required ?? false}
          options={choices?.map((choice) => choice?.name ?? "") ?? []}
        />
      </div>
      {conditionalFields && (
        <FormFieldRenderer
          fieldGroupKey="FormSectionSelectChoicesConditionalFields"
          leftFieldGroupKey="FormSectionSelectChoicesConditionalFieldsLeftSection"
          rightFieldGroupKey="FormSectionSelectChoicesConditionalFieldsRightSection"
          slices={
            conditionalFields as Maybe<
              Maybe<{ fieldGroupName: string; [key: string]: unknown }>[]
            >
          }
        />
      )}
    </>
  );
}
